import React from 'react';
import './styles.css';





export const RosaAyudanteIzquierda = () => {


  return (
    <>


        <div className='RosaAyudanteIzquierda-Container'>

                <div className='RosaAyudanteIzquierda-maestra' />

                <div className='RosaAyudanteIzquierda-nombre-texto-container'>
                    
                      <div className='RosaAyudanteIzquierda-nombre' />

                      <div className='RosaAyudanteIzquierda-texto'>

                          Educadora Infantil y Licencida en Periodismo. Directora del centro y apoyo educativo.

                      </div>

                </div>

        </div>


    </>
  )
}
